/**
 * Formats how a contact should be displayed in the contacts list.
 *
 * - A company contact (isCompany === true) shows its own name only.
 * - An individual who belongs to a company shows "Company, Individual".
 * - A lone individual shows their name only.
 *
 * The backend returns the parent company's name in `company` (string) and
 * its id in `companyId`. For company contacts, `firstName` holds the
 * company name (Odoo stores it that way via `res.partner.name`).
 *
 * @param {{
 *   isCompany?: boolean,
 *   firstName?: string,
 *   lastName?: string,
 *   company?: string | null,
 *   companyId?: number | null,
 * }} contact
 * @returns {string}
 */
export function formatContactName(contact) {
  if (!contact) return '';
  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(' ').trim();

  if (contact.isCompany) {
    return fullName;
  }

  if (contact.company) {
    return `${contact.company}, ${fullName}`.trim();
  }

  return fullName;
}
